import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';
import { useRoleAssumption } from '../../context/RoleAssumptionContext';
import './Settings.css';

export default function Settings() {
  const { t, i18n } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const {
    effectiveIsPlatformAdmin,
    effectiveIsCRAAdmin,
    effectiveIsBankAdmin
  } = useRoleAssumption();
  const navigate = useNavigate();

  const currentLang = i18n.language;

  const switchLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('bench-language', lang);
    document.documentElement.setAttribute('lang', lang);
  };

  // Check if user has any admin role (using effective role)
  const isAdmin = effectiveIsPlatformAdmin || effectiveIsCRAAdmin || effectiveIsBankAdmin;

  return (
    <div className="settings">
      <h1 className="page-title">{t('settings.title')}</h1>

      {/* Admin Panel Link - Only for Admin Roles */}
      {isAdmin && (
        <div className="section">
          <h2>{t('settings.administration')}</h2>
          <div className="setting-item">
            <div className="setting-info">
              <h3>{t('settings.adminPanel')}</h3>
              <p>
                {effectiveIsPlatformAdmin
                  ? t('settings.adminDescPlatform')
                  : effectiveIsCRAAdmin
                  ? t('settings.adminDescCRA')
                  : t('settings.adminDescBank')}
              </p>
            </div>
            <button onClick={() => navigate('/admin')} className="admin-button">
              {t('settings.goToAdmin')} →
            </button>
          </div>
        </div>
      )}

      <div className="section">
        <h2>{t('settings.appearance')}</h2>
        <div className="setting-item">
          <div className="setting-info">
            <h3>{t('settings.theme')}</h3>
            <p>{t('settings.themeDescription')}</p>
          </div>
          <button onClick={toggleTheme} className="theme-button">
            {theme === 'light' ? t('settings.switchToDark') : t('settings.switchToLight')}
          </button>
        </div>
        <div className="setting-item">
          <div className="setting-info">
            <h3>{t('settings.language')}</h3>
            <p>{t('settings.languageDescription')}</p>
          </div>
          <div className="language-switcher">
            <button
              className={`lang-option ${currentLang === 'es' ? 'active' : ''}`}
              onClick={() => switchLanguage('es')}
            >
              ES
            </button>
            <button
              className={`lang-option ${currentLang === 'en' ? 'active' : ''}`}
              onClick={() => switchLanguage('en')}
            >
              EN
            </button>
          </div>
        </div>
      </div>

      <div className="section">
        <h2>{t('settings.about')}</h2>
        <p>{t('settings.version')}</p>
        <p className="text-muted">{t('settings.aboutDescription')}</p>
      </div>
    </div>
  );
}
